import { Text } from '@cko/primitives';
import styled from 'styled-components';
export const Label = styled(Text) `
  color: var(--base-text-secondary);
`;
